import { isDeepUndefined, isNonNullable, } from "@ascend-ltd/logic-helpers";
import * as yup from "yup";
import { Schema } from "../../schema";
import { MultipleValueObject } from "../base-value-object";
// prettier-ignore
export const PREFECTURES = [
    { name: "北海道", kana: "ホッカイドウ", roman: "hokkaido" },
    { name: "青森県", kana: "アオモリケン", roman: "aomori" },
    { name: "岩手県", kana: "イワテケン", roman: "iwate" },
    { name: "宮城県", kana: "ミヤギケン", roman: "miyagi" },
    { name: "秋田県", kana: "アキタケン", roman: "akita" },
    { name: "山形県", kana: "ヤマガタケン", roman: "yamagata" },
    { name: "福島県", kana: "フクシマケン", roman: "fukushima" },
    { name: "茨城県", kana: "イバラキケン", roman: "ibaraki" },
    { name: "栃木県", kana: "トチギケン", roman: "tochigi" },
    { name: "群馬県", kana: "グンマケン", roman: "gunma" },
    { name: "埼玉県", kana: "サイタマケン", roman: "saitama" },
    { name: "千葉県", kana: "チバケン", roman: "chiba" },
    { name: "東京都", kana: "トウキョウト", roman: "tokyo" },
    { name: "神奈川県", kana: "カナガワケン", roman: "kanagawa" },
    { name: "新潟県", kana: "ニイガタケン", roman: "niigata" },
    { name: "富山県", kana: "トヤマケン", roman: "toyama" },
    { name: "石川県", kana: "イシカワケン", roman: "ishikawa" },
    { name: "福井県", kana: "フクイケン", roman: "fukui" },
    { name: "山梨県", kana: "ヤマナシケン", roman: "yamanashi" },
    { name: "長野県", kana: "ナガノケン", roman: "nagano" },
    { name: "岐阜県", kana: "ギフケン", roman: "gifu" },
    { name: "静岡県", kana: "シズオカケン", roman: "shizuoka" },
    { name: "愛知県", kana: "アイチケン", roman: "aichi" },
    { name: "三重県", kana: "ミエケン", roman: "mie" },
    { name: "滋賀県", kana: "シガケン", roman: "shiga" },
    { name: "京都府", kana: "キョウトフ", roman: "kyoto" },
    { name: "大阪府", kana: "オオサカフ", roman: "osaka" },
    { name: "兵庫県", kana: "ヒョウゴケン", roman: "hyogo" },
    { name: "奈良県", kana: "ナラケン", roman: "nara" },
    { name: "和歌山県", kana: "ワカヤマケン", roman: "wakayama" },
    { name: "鳥取県", kana: "トットリケン", roman: "tottori" },
    { name: "島根県", kana: "シマネケン", roman: "shimane" },
    { name: "岡山県", kana: "オカヤマケン", roman: "okayama" },
    { name: "広島県", kana: "ヒロシマケン", roman: "hiroshima" },
    { name: "山口県", kana: "ヤマグチケン", roman: "yamaguchi" },
    { name: "徳島県", kana: "トクシマケン", roman: "tokushima" },
    { name: "香川県", kana: "カガワケン", roman: "kagawa" },
    { name: "愛媛県", kana: "エヒメケン", roman: "ehime" },
    { name: "高知県", kana: "コウチケン", roman: "kochi" },
    { name: "福岡県", kana: "フクオカケン", roman: "fukuoka" },
    { name: "佐賀県", kana: "サガケン", roman: "saga" },
    { name: "長崎県", kana: "ナガサキケン", roman: "nagasaki" },
    { name: "熊本県", kana: "クマモトケン", roman: "kumamoto" },
    { name: "大分県", kana: "オオイタケン", roman: "oita" },
    { name: "宮崎県", kana: "ミヤザキケン", roman: "miyazaki" },
    { name: "鹿児島県", kana: "カゴシマケン", roman: "kagoshima" },
    { name: "沖縄県", kana: "オキナワケン", roman: "okinawa" },
];
const prefectureRegexp = new RegExp(`^(${PREFECTURES.map((prefectures) => prefectures.name).join("|")})$`); // yup 用正規表現
export class Address extends MultipleValueObject {
    prefecture;
    address1;
    address2;
    constructor(args) {
        if (isDeepUndefined(args)) {
            throw new Error("invalid input. At least one of prefecture, address1 and address2 is required.");
        }
        super(args);
        this.prefecture = args.prefecture;
        this.address1 = args.address1;
        this.address2 = args.address2;
    }
    validator(args) {
        return this.validate(args, Address.schema);
    }
    equals(t) {
        return this.toString() === t?.toString();
    }
    getValue() {
        return {
            prefecture: this.prefecture,
            address1: this.address1,
            address2: this.address2,
        };
    }
    toString() {
        return [this.prefecture, this.address1, this.address2]
            .filter(isNonNullable)
            .join(" ");
    }
    static schema(required = true) {
        return Schema.required({
            prefecture: yup.string().matches(prefectureRegexp).label("都道府県"),
            address1: yup.string().label("住所1"),
            address2: yup.string().label("住所2"),
        }, required);
    }
}
//# sourceMappingURL=address.js.map